import React, { useState } from 'react'

const RadioGroup = ({items, returnSelected, showDescriptions, hasError, inputLabel, requiredField, inline, preSelectedIndex}) => {

    const [selectedOption, setSelectedOption] = useState(preSelectedIndex)

    const selectOption = (index, item) => {
        setSelectedOption(index)
        returnSelected(item)
    }

    return (
        <>
            <label 
                className={`text-sm lg:text-md cursor-text z-10 relative py-1 transition duration-200  
                ${hasError ? 'text-red-600' : 'text-gray-500'}`}
            >
             {requiredField && requiredField === true && <span className='text-red-600'>*</span>} {inputLabel}
            </label>
            <div className={`w-full ${inline && 'flex flex-wrap gap-x-8 gap-y-4 items-center'}`}>
                {items.map((item, itemIndex)=>(
                <div onClick={()=>{selectOption(itemIndex, item)}} key={itemIndex} className={`${showDescriptions ? 'w-full' : 'w-max' } flex items-start gap-x-2 my-3 py-2 px-2 cursor-pointer border rounded-[8px] ${selectedOption === itemIndex ? 'border-vcm-purple bg-vcm-light-purple bg-opacity-10' : 'border-transparent'}`}>
                    <button 
                            className={`flex items-center justify-center rounded-full w-5 h-5 border-2 mt-[1px] transition duration-200 text-white bg-white 
                            ${hasError ? 'border-red-600' : 'border-vcm-purple'}`
                        } 
                        onClick={()=>{selectOption(itemIndex, item)}}
                    >
                        {selectedOption === itemIndex && <div className='w-2 h-2 transition duration-200 rounded-full bg-vcm-purple'></div>}
                    </button>

                    <div>
                        <label className={`text-sm cursor-pointer block ${hasError ? 'text-red-600' : 'text-black'}`}>
                            {item.label}
                        </label>
                        {showDescriptions && item.description && item.description !== '' && <label className='block text-sm text-gray-800 mt-1'>{item.description}</label>}
                    </div>
                    
                </div>
                ))
                }
            </div>
        </>
    )
}

export default RadioGroup